import React from "react";

const DeleteConfirmModal = ({ isOpen, toggle, onConfirm, itemName }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* overlay */}
            <div
                className="absolute inset-0 bg-black bg-opacity-50"
                onClick={toggle}
            ></div>

            {/* modal */}
            <div className="relative bg-white w-96 rounded-lg shadow-lg p-6 z-10 animate-fadeIn">
                <h2 className="text-xl font-semibold mb-3">
                    Are you sure you want to delete{" "}
                    <span className="font-semibold text-red-600">
                        {itemName || "this record"}
                    </span>
                    ?
                </h2>

                {/* Buttons */}
                <div className="flex justify-end gap-4">
                    <button
                        className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded-md"
                        onClick={toggle}
                    >
                        Cancel
                    </button>

                    <button
                        className="px-4 py-2 bg-red-600 text-white hover:bg-red-700 rounded-md"
                        onClick={onConfirm}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
